<div class="navigation-breadcrumb">
  <span class="breadcrumb-text">
    <a (click)="navigationTOVendor('vm')">{{ rtodrill.VendorManagement }}</a> /
    <a (click)="navigationTOVendor('vl')">{{ rtodrill.VendorList }}</a> /
    {{ rtodrill.ContractorList }}
  </span>
</div>

<div class="contractor-list-container">
  <div class="contractor-search-table-container">
    <div class="contractor-list-search">
      <div class="contractor-title">
        <span>{{ rtoData.BREADCRUMBS.LIST_OF_CONTRACTORS }}</span>
      </div>
      <div class="search-bar-container">
        <div class="chip-container">
          <emerald-chip
            [value]="rtoTypeBadge()"
            [label]="rtoTypeBadge()"
          ></emerald-chip>
        </div>
        <div class="search-child">
          <emerald-input
            [label]="rtoData.LABELS.SEARCH"
            trailingIcon="search"
            [value]="filterValue"
            (keyup)="searchContractor($event)"
          >
            <emerald-icon
              *ngIf="filterValue?.length"
              icon="close"
              (click)="clearInput()"
            ></emerald-icon>
          </emerald-input>
        </div>
        <div class="filter-child">
          <emerald-menu
            [opened]="opened"
            position="bottom_end"
            [targetElement]="navTemplate"
            [menuTemplate]="menuTemplate"
            (openChange)="opened = $event"
          ></emerald-menu>
          <ng-template #navTemplate>
            <emerald-button
              [label]="rtoData.LABELS.FILTER"
              [size]="EmeraldButtonSize.SMALL"
              [type]="EmeraldButtonVariant.SECONDARY"
              icon="filter_list"
              [iconPosition]="EmeraldButtonAlignment.LEFT"
              (onClick)="opened = !opened"
            ></emerald-button>
          </ng-template>
          <ng-template #menuTemplate>
            <app-vendor-rto-drill-filter
              [contractorData]="contractorData"
              (onApplyFilter)="handleFilterApply($event)"
              (onResetFilter)="handleFilterReset()"
            ></app-vendor-rto-drill-filter>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="contractor-list-table">
      <ng-container *ngIf="contractorData?.length; else noDataTemplate">
        <emerald-datatable
          [columnDefs]="columnDefs"
          [rowData]="contractorData"
          [paginationParams]="paginationParams"
          [customCellTemplate]="{
            daysPresent: customActionColumn,
            contractorName: customNameColumn,
            rtoDays: customRTOColumn,
          }"
        ></emerald-datatable>
      </ng-container>

      <ng-template #noDataTemplate>
        <section class="records-container" aria-label="Records section">
          <div class="empty-state">
            <h2 class="empty-state-title">{{ errorMsg }}</h2>
            <img
              [src]="imageSrc"
              [alt]="rtoData.LABELS.NO_RECORDS"
              class="empty-state-image"
            />
          </div>
        </section>
      </ng-template>

      <ng-template #customNameColumn let-level="level" let-eachRow="eachRow">
        <div class="member">
          <div class="name">
            <a
              [routerLink]="[
                '/vendor-management/contractor-profile',
                eachRow?.employeeId,
              ]"
              [queryParams]="{
                vendorId: vendorId,
                type: rtoType,
                month: month,
                year: year,
                employeeId: employeeId,
              }"
              style="cursor: pointer; text-decoration: underline"
              >{{ eachRow?.contractorName }}</a
            >
          </div>
          <div class="title">{{ eachRow?.designation }}</div>
        </div>
      </ng-template>
      <ng-template #customRTOColumn let-level="level" let-eachRow="eachRow">
        <div class="member">
          <div class="name">{{ eachRow?.rtoDays }} Days</div>
        </div>
      </ng-template>

      <ng-template #customActionColumn let-level="level" let-eachRow="eachRow">
        <div class="action">
          <div
            class="notify-icon-container"
            [title]="rtoData.LABELS.VIEW_RTO_CALENDAR"
            (click)="openCalendar(eachRow)"
          >
            <emerald-icon
              icon="date_range"
              [fontsizeInRem]="iconFontSize"
            ></emerald-icon>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<div *ngIf="calendarOpened" class="modal-container">
  <div class="dim-background" (click)="closeCalendar()"></div>
  <div class="modal-content">
    <app-timesheet-calendar
      *ngIf="calendarOpened"
      class="rto-drill-calendar"
      [componentName]="componentName"
      [candidateDetails]="selectedContractor"
      [selectedyear]="year"
      [selectedmonth]="month.toString().includes('-') ? month.toString().split('-')[0] : month"
      (closeComponent)="closeCalendar()"
    ></app-timesheet-calendar>
  </div>
</div>
